/** A new game (docs/spec/02 §2, §9). */

import { newDirector } from './director';
import { beginStage } from './flow';
import { newFormation } from './formation';
import { newPlayer } from './player';
import { newPowers } from './powerups';
import { Rng } from './rng';
import { newSpawner } from './spawn';
import { nextLifeAfter } from './score';
import { FIGHTER, NOVA } from './tuning';
import type { GameConfig, GameState } from './types';

export function createGame(config: GameConfig): GameState {
  const fighters = Math.max(1, Math.floor(config.fighters ?? FIGHTER.startFighters));
  const s: GameState = {
    config,
    mode: config.mode,
    rng: new Rng(config.seed),
    tick: 0,
    stage: 0,
    stageKind: 'formation',
    phase: 'intro',
    phaseT: 0,
    score: 0,
    lives: fighters - 1,
    nextLifeAt: nextLifeAfter(config.mode, 0),
    player: newPlayer(),
    powers: newPowers(config.mode === 'supernova' ? NOVA.startNovas : 0),
    formation: newFormation(),
    spawner: newSpawner(),
    director: newDirector(),
    enemies: [],
    shots: [],
    bombs: [],
    capsules: [],
    beam: null,
    rescue: null,
    empress: null,
    challenge: null,
    chain: 0,
    chainClock: 0,
    dropMeter: 0,
    lastCapsule: null,
    challenges: 0,
    empresses: 0,
    capturedMsg: 0,
    nextId: 1,
    nextVolley: 1,
    stats: { shots: 0, hits: 0, bestChain: 0 },
    events: [],
  };
  beginStage(s, Math.max(1, Math.floor(config.startStage ?? 1)));
  return s;
}
